import { useState } from 'react';

/** A read-only value with a copy button (commands, links). */
export function CopyField({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);
  const copy = () => { void navigator.clipboard.writeText(value).then(() => { setCopied(true); }); };
  return (
    <div className="copy-row">
      <input readOnly value={value} aria-label={label} onFocus={(e) => { e.target.select(); }} />
      <button type="button" onClick={copy}>{copied ? 'Copied' : 'Copy'}</button>
    </div>
  );
}
